module.exports = __webpack_public_path__ + "img/email.911a4d7e.svg";